import * as React from "react";
const SvgMore = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6 4L10 8L6 12", stroke: "#A3A3A3", strokeWidth: 1.2, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgMore;
